<div class="maintenance-banner">
  <div class="icon">
    <mat-icon>warning_amber</mat-icon>
  </div>
  <div class="maintenance-description">
    <ng-content></ng-content>
  </div>
</div>
